var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcActiveStudentManage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_164_8942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 3.68629 4.68629 1 8 1H36C39.3137 1 42 3.68629 42 7V35C42 38.3137 39.3137 41 36 41H8C4.68629 41 2 38.3137 2 35V7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5H36C39.0376 1.5 41.5 3.96243 41.5 7V35C41.5 38.0376 39.0376 40.5 36 40.5H8C4.96243 40.5 2.5 38.0376 2.5 35V7C2.5 3.96243 4.96243 1.5 8 1.5Z",
    stroke: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4167 20.5833V16H28.6667V20.5833C28.6667 20.9285 28.3869 21.2083 28.0417 21.2083C27.6965 21.2083 27.4167 20.9285 27.4167 20.5833Z",
    fill: "#092E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 19.333V16.833H18.6667V19.333C18.6667 21.1739 20.1591 22.6663 22 22.6663C23.8409 22.6663 25.3334 21.1739 25.3334 19.333Z",
    fill: "#092E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.357 15.6191L20.9849 13.1178C21.6314 12.8305 22.3693 12.8305 23.0157 13.1178L28.6436 15.6191C28.9735 15.7658 28.9735 16.234 28.6436 16.3806L23.0157 18.882C22.3693 19.1692 21.6314 19.1692 20.9849 18.882L15.357 16.3806C15.0271 16.234 15.0271 15.7658 15.357 15.6191Z",
    fill: "#092E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9164 23.8331L22.5925 25.1717C22.2664 25.5015 21.7337 25.5015 21.4075 25.1717L20.0837 23.8331C19.8792 23.6264 19.5807 23.5382 19.3017 23.6203C16.9641 24.3077 15.3334 25.8609 15.3334 27.6669C15.3334 28.5873 16.0796 29.3335 17 29.3335H27C27.9205 29.3335 28.6667 28.5873 28.6667 27.6669C28.6667 25.8609 27.036 24.3077 24.6984 23.6203C24.4194 23.5382 24.1208 23.6264 23.9164 23.8331Z",
    fill: "#092E5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_164_8942",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_8942"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_8942",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActiveStudentManage);
export default __webpack_public_path__ + "static/media/ic_active_student_manage.603815aaf84ec346258cb1fd2f69fa72.svg";
export { ForwardRef as ReactComponent };